import * as React from 'react'
import { ReactElement } from 'react'
import { BaseComboboxProps } from '../BaseCombobox'
import I18NCombobox from './I18NCombobox'
import useTaskStatuses from '../../../hooks/useTaskStatuses'
import { TaskStatus } from '../../../context/GlobalContext'

export type TaskStatusComboboxProps = Omit<
    BaseComboboxProps<TaskStatus>,
    'getEntityLabel' | 'getEntityValue' | 'entities'
> &
    Partial<Pick<BaseComboboxProps<TaskStatus>, 'getEntityLabel'>>

export default function TaskStatusCombobox(props: TaskStatusComboboxProps): ReactElement {
    const { taskStatuses } = useTaskStatuses()

    return (
        <I18NCombobox<TaskStatus>
            entities={taskStatuses}
            idKey={'alpha'}
            placeholderKey={'base.taskstatuscombobox.placeholder'}
            {...props}
        />
    )
}
